module.exports = __webpack_public_path__ + "static/img/all-tab.b984e5b.png";